import React, { useRef } from 'react';
import { SystemIcon } from '@storeblocks/icon';
import { Input } from './styled';
import IconButton from '../IconButton';
function FileUpload(_a) {
    var id = _a.id, label = _a.label, trackId = _a.trackId, onUploadFile = _a.onUploadFile;
    var inputRef = useRef(null);
    var handleClick = function (e) {
        e.preventDefault();
        inputRef.current.click();
    };
    var handleChange = function (event) {
        onUploadFile(event.target.files);
    };
    return (React.createElement(React.Fragment, null,
        label ? (React.createElement(IconButton, { iconLeft: "attachment", onClick: handleClick, variant: "outlined" }, label)) : (React.createElement(IconButton, { variant: "icon", onClick: handleClick },
            React.createElement(SystemIcon, { name: "attachment", title: "attachment" }))),
        React.createElement(Input, { id: id, name: id, type: "file", multiple: true, onChange: handleChange, ref: inputRef, "data-trackid": "button-".concat(trackId, "_attachments|").concat(label) })));
}
export default FileUpload;
